import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ViewCompactAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"view_compact_alt"}/>
}
